import React from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import Card, { CardBody, CardHeader, CardTitle } from '../../components/Card';
import * as actions from '../../actions';
import LanguageSelectSoftware from '../../elements/User/Account/LanguageSelectSoftware';
import LanguageSelectApps from '../../elements/User/Account/LanguageSelectApps';
import { getTranslationKey } from '../../modules/utils/helpers';

interface LanguageProps {
  languageApp?: number;
  updateDefaultUserLanguages?: (data: { languageApp: number }) => void;
}

interface RootState {
  auth: {
    languageApp?: number;
  };
}

const Language: React.FC<LanguageProps> = ({ languageApp, updateDefaultUserLanguages }) => (
  <div className="animated fadeIn">
    <Row>
      <Col sm="12" md="12" lg="6">
        <Card>
          <CardHeader>
            <CardTitle>{getTranslationKey('languageSettings')}</CardTitle>
          </CardHeader>
          <CardBody>
            <p>{getTranslationKey('languageSettingsDesc')}</p>
            <LanguageSelectSoftware />
            <div className="m-t-10" />
            <LanguageSelectApps
              selectedValue={languageApp}
              label={getTranslationKey('selectLanguageApps')}
              onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) =>
                updateDefaultUserLanguages &&
                updateDefaultUserLanguages({
                  languageApp: Number(value)
                })
              }
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

function mapStateToProps({ auth: { languageApp } }: RootState): Pick<LanguageProps, 'languageApp'> {
  return { languageApp };
}

export default connect(mapStateToProps, actions)(Language);
